import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { Provider } from 'react-redux'
import { persistor, store } from './store/store.ts'
import { PersistGate } from 'redux-persist/integration/react'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import ScrollToTop from './utility/ScrollTop.ts'
import { NotificationProvider } from './context/NotificationContext.tsx'

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <NotificationProvider>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename={import.meta.env.VITE_PUBLIC_URL}>
          <Toaster position="top-left" />
          <ScrollToTop />
          <App />
        </BrowserRouter>
      </PersistGate>
    </NotificationProvider>
  </Provider>,
)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}
